export default "__VITE_ASSET__B8oB3XhL__"